<div class="sidebar included">
	<app-sidebar-header [title]="INDRA_getTranslationKey('milesEarnedTitle','title') | ibeadmin:'sync'">
	</app-sidebar-header>
	<div class="sidebar__body sl--scrollable" #sidebar__body>
		<app-flight-route [flight]="flightRouteInput"></app-flight-route>
		<div class="sidebar-flight-text">
			<h2 class="title-h2">{{ INDRA_getTranslationKey('milesPerPassenger','title') | ibeadmin:'sync' }}</h2>
			<div *ngFor="let passenger of passengers" class="border sidebar-flight-text">
				<div class="grid no-padding">
					<div class="col-4 col-tp-4 col-p-12 no-padding">
						<p class="bold">{{INDRA_printPassengerName(passenger)}}</p>
					</div>
					<!--NOTE: ngIf the passenger is a frequent flyer member from TAP -->
					<div class="col-8 col-tp-8 col-p-12" *ngIf="passenger.tierLevelFF && passenger.FFnum && passenger.typePax != 'INF'">
						<p class="">
							<app-svg class="list--checked__icon" svg="sprite.svg#misc--check" aria-hidden="true"></app-svg><span
								class="bold">{{INDRA_getLoyaltyMilesPerTierByFlightCardId(this.flight.idFlight.toString(), this.passenger.tierLevelFF,this.flight.assignedFlightId.toString())}}
								{{ 'ancillaries.detailed.miles' | ibeadmin:'sync' }}
							</span> {{ INDRA_getTranslationKey('earnedTAPMiles','text') | ibeadmin:'sync' }}
						</p>
					</div>
					<!-- if not, show the block below -->
					<div class="col-8 col-tp-8 col-p-12"
						*ngIf="!passenger.tierLevelFF && passenger.typePax != 'INF'">
						<p class="">{{ INDRA_getTranslationKey('onlyMembers','text') | ibeadmin:'sync' }}</p>
						<p>{{ INDRA_getTranslationKey('youcouldearn','text') | ibeadmin:'sync' }}
							<strong>{{INDRA_getLoyaltyMiles(this.flight.idFlight.toString(),passenger.tierLevelFF,this.flight.assignedFlightId.toString())}}
								{{ INDRA_getTranslationKey('miles','text') | ibeadmin:'sync' }}</strong></p>
						<a (click)="INDRA_handleOpenDetailsSidebar(passenger.idPax)"
							class="link extras-feature__link link--external" target="_blank"
							 role="button"
							 href="javascript:;"
							[attr.aria-label]="INDRA_getTranslationKey('openDialogForMilesAndGo','aria')">
							{{ INDRA_getTranslationKey('addMemberNumber','link') | ibeadmin:'sync' }}
						</a>
					</div>
					<!-- if not, show the block below -->
					<div class="col-8 col-tp-8 col-p-12"
						*ngIf="!passenger.FFid && !passenger.FFnum && passenger.typePax == 'INF'">
						<p class="">{{ INDRA_getTranslationKey('notApplicable','text') | ibeadmin:'sync' }}</p>
					</div>
				</div>
			</div>
		</div>
		<div class="sidebar-flight-text" *ngIf="!isBookingView && !isReviewTTTCompletion && INDRA_showUpgrade()">
			<p class="muted">{{ INDRA_getTranslationKey('upgrade','text') | ibeadmin:'sync' }}</p>
			<button class="button "
				(click)="INDRA_upgradeWithCash()" [attr.aria-label]="INDRA_getTranslationKey('openDialogUpgrade','aria') | ibeadmin:'sync'">{{ INDRA_getTranslationKey('upgrade','button') | ibeadmin:'sync' }}
			</button>
		</div>
		<div class="sidebar-flight-text border" *ngIf="!hasAllFrequentFlyerPassenger">
			<h2 class="title-h2">{{ INDRA_getTranslationKey('tapMilesAndGo','title') | ibeadmin:'sync' }}</h2>
			<div *ngIf="isBookingView">
				<p>Only TAP Miles&go members and members of other Star Alliance Loyalty programmes earn miles.</p>
				<ul>
					<li>When paying the same price for flights, TAP Miles&Go Gold members earn more miles than Silver members,
						which, in turn, earn more miles that TAP Miles&Go members.</li>
					<li>Once you have finished your purchase, TAP will show you how much each TAP Miles&Go passenger will earn
						with this trip.</li>
					<li>Miles are credited after flying.</li>
				</ul>
			</div>
			<p> {{ INDRA_getTranslationKey('notYetAMember','text') | ibeadmin:'sync' }}<a href="#"
					class="link extras-feature__link"> {{ INDRA_getTranslationKey('signUp','link') | ibeadmin:'sync' }}</a>
				{{ INDRA_getTranslationKey('earnMilesNow','text') | ibeadmin:'sync' }}</p>
		</div>

		<p (click)="INDRA_goToUrl('externalURLs.earnMiles')"><a class="link" aria-label="Learn more, open window" href="javascript:;">Learn more</a> </p>
		
		<div class="sidebar-flight-text border">
			<p><a
				href="javascript:;"
				role="button"
				class="link extras-feature__link"
					[attr.aria-label]="INDRA_getTranslationKey('openDialogClose','aria') | ibeadmin:'sync'"
					(click)="INDRA_handleClose()">{{ INDRA_getTranslationKey('close','link') | ibeadmin:'sync' }}
				</a>
			</p>
		</div>
	</div>
	<div #sidebar__footer class="sidebar__footer "></div>
</div>
